export default "__VITE_ASSET__Cre9G97x__"